<template>
	<div class="position-relative" style="z-index: 9999">
	  <p class="font-weight-bold">
		{{ $t("views.seller.edit_product.text_1117") }}</p>
	  <div class="d-flex justify-content-center" v-if="loading">
		<b-spinner label="Loading..."></b-spinner>
	  </div>
	  <section class="container-arquivos" v-else>
		<b-row key="nao-encontrado">
		  <p class="nao-encontrado mt-3">
			{{ $t('seller.products.listagem_club.text_504') }}
		  </p>
		</b-row>
		<div class="lista-entrega lista-arquivos mt-4">
		  <div>
			<b-form data-vv-scope="club" v-if="userOk">
			  <b-row>
				<b-col cols="12" md="10" v-if="newClub.flag" data-anima="top">
				  <b-form-group
					  :label="$t('seller.products.greenn_club.text_387')"
					  label-for="project_name"
				  >
					<b-form-input
						v-model="newClub.name"
						name="project_name"
						id="project_name"
						:placeholder="$t('seller.products.greenn_club.text_1919')"
						v-validate="'required'"
						autocomplete="off"
					/>
					<b-form-invalid-feedback
						:state="!errors.has('club.project_name')"
					>
					  {{ $t("seller.products.greenn_club.text_388") }}
					</b-form-invalid-feedback>
				  </b-form-group>
				  <b-form-group
					  :label="$t('seller.products.greenn_club.text_389')"
					  label-for="subdomain"
				  >
					<b-form-input
						v-model="newClub.subdomain"
						name="subdomain"
						id="subdomain"
						autocomplete="off"
						:placeholder="$t('seller.products.greenn_club.text_390')"
						v-validate="{
					  required: true,
					  regex: /^[a-z\-_0-9]{6,30}$/i,
					}"
					/>
					<p class="sub-dominio">
					  {{ newClub.subdomain }}.voompplay.com.br
					</p>
					<b-form-invalid-feedback
						:state="!errors.has('club.subdomain')"
					>
					  {{ $t("seller.products.greenn_club.text_391") }}
					</b-form-invalid-feedback>
				  </b-form-group>
				</b-col>
  
				<b-col cols="12" md="10" data-anima="top" v-if="!newClub.flag">
				  <b-form-group
					  :label="$t('seller.products.greenn_club.text_395')"
					  label-for="projeto"
				  >
					<b-form-select
						v-model="club.site_id"
						:options="club.options_projetos"
						name="projeto"
						id="projeto"
						:placeholder="$t('seller.products.greenn_club.text_396')"
						v-validate="'required'"
						@change="changeProjeto"
					>
					</b-form-select>
					<b-form-invalid-feedback :state="!errors.has('club.projeto')">
					  {{ $t("seller.products.greenn_club.text_396") }}
					</b-form-invalid-feedback>
				  </b-form-group>
  
				  <b-form-group
					  :label="$t('seller.products.greenn_club.text_1920')"
					  label-for="tipo"
					  v-show="club.site_id"
				  >
					<b-form-select
						v-model="club.data.access"
						:options="club.options_conexao_tipo"
						@input="handleTypeChange"
						name="tipo"
						id="tipo"
						:placeholder="$t('seller.products.greenn_club.text_1921')"
						v-validate="'required'"
						@change="changeClub"
					>
					</b-form-select>
					<b-form-invalid-feedback :state="!errors.has('club.tipo')">
					  {{ $t("seller.products.greenn_club.text_397") }}
					</b-form-invalid-feedback>
				  </b-form-group>
				</b-col>
			  </b-row>
			  <div v-if="!newClub.flag && club.data.access">
				<div v-show="club.options.length">
				  <b-form-group
					  :label="$t('seller.products.greenn_club.text_398')"
					  label-for="classroom"
					  v-if="club.data.access === 'course_class'"
					  data-anima="top"
				  >
					<multiselect
						v-model="club.data.course_class_id"
						:options="club.options"
						:value="club.data.course_class_id"
						@input="handleSelectionChange"
						:multiple="true"
						:close-on-select="false"
						:clear-on-select="false"
						:preserve-search="true"
						:placeholder="$t('seller.products.greenn_club.text_399')"
						label="text"
						track-by="text"
						selectLabel=""
						deselectLabel=""
						selectedLabel="✔️"
						id="classroom"
						name="classroom"
						v-validate="'required'"
					>
					</multiselect>
					<a
						v-if="!checkText()"
						href="#"
						@click.prevent="selecionarTodos('course_class')"
						class="legenda-form-tp"
					>{{ $t('seller.products.greenn_club.text_419') }}
					</a
					>
					<a
						v-else
						href="#"
						@click.prevent="removerTodos('course_class')"
						class="legenda-form-tp"
					>{{ $t('seller.products.greenn_club.text_420') }}
					</a
					>
					<p class="legenda-form">
					  • {{ $t("seller.products.greenn_club.text_400") }}
					</p>
					<b-form-invalid-feedback
						:state="!errors.has('club.classroom')"
					>
					  {{ $t("seller.products.greenn_club.text_401") }}
					</b-form-invalid-feedback>
				  </b-form-group>
  
				  <b-form-group
					  :label="$t('seller.products.greenn_club.text_402')"
					  label-for="membership_id"
					  v-if="club.data.access === 'signature'"
					  data-anima="top"
				  >
					<multiselect
						v-model="club.data.signature_ids"
						:options="club.options"
						:value="club.data.signature_ids"
						@input="handleSelectionChange"
						:multiple="true"
						:close-on-select="false"
						:clear-on-select="false"
						:preserve-search="true"
						:placeholder="$t('seller.products.greenn_club.text_402')"
						label="text"
						track-by="text"
						selectLabel=""
						deselectLabel=""
						selectedLabel="✔️"
						class="multi-select-input"
						name="membership_id"
						id="membership_id"
						v-validate="'required'"
					>
					</multiselect>
					<a
						v-if="!checkText()"
						href="#"
						@click.prevent="selecionarTodos('signature')"
						class="legenda-form-tp"
					>{{ $t('seller.products.greenn_club.text_419') }}</a
					>
					<a
						v-else
						href="#"
						@click.prevent="removerTodos('signature')"
						class="legenda-form-tp"
					>{{ $t('seller.products.greenn_club.text_420') }}
					</a
					>
  
					<p class="legenda-form">
					  • {{ $t("seller.products.greenn_club.text_403") }}
					</p>
					<b-form-invalid-feedback
						:state="!errors.has('club.data.membership_id')"
					>
					  {{ $t("seller.products.greenn_club.text_404") }}
					</b-form-invalid-feedback>
				  </b-form-group>
				</div>
				<div v-show="!club.options.length">
				  <p class="legenda" data-anima="bottom">
					{{ $t("seller.products.greenn_club.text_405") }}
				  </p>
				</div>
			  </div>
			</b-form>
			<div v-else class="dados-incompletos" data-anima="bottom">
			  <h6>{{ $t("seller.products.greenn_club.text_406") }}</h6>
			  <p>
				{{ $t("seller.products.greenn_club.text_407") }}
			  </p>
			  <p>
				{{ $t("seller.products.greenn_club.text_408") }}
			  </p>
			</div>
			<div class="mt-4">
			  <div v-if="userOk" class="action-club d-flex justify-content-start">
				<BaseButton
					variant="secondary_outline"
					class="novo-projeto mb-2"
					@click="toggleNewClub"
				>
				  {{ newClub.flag_name }}
				</BaseButton>
				<BaseButton
					variant="secondary"
					class="novo-projeto mb-2 ml-2"
					:disabled="loading || errors.has('club.subdomain')"
					@click="novoClub"
					v-if="newClub.flag"
				>
				  {{ $t("seller.products.greenn_club.text_410") }}
				</BaseButton>
				<BaseButton
					variant="secondary"
					class="novo-projeto mb-2 ml-2"
					:disabled="hasContent || loading"
					@click="adicionarClub"
					v-if="userOk && !newClub.flag"
				>
				  {{ $t("seller.products.greenn_club.text_409") }}
				</BaseButton>
			  </div>
			</div>
		  </div>
		</div>
	  </section>
	  <div class="d-flex justify-content-end mt-4" v-if="!userOk">
		<BaseButton
			variant="info3"
			:disabled="loading"
			@click="atualizarConta"
		>
		  {{ $t("seller.products.greenn_club.text_411") }}
		</BaseButton>
	  </div>
	</div>
  </template>
  
  <script>
  import Multiselect from "vue-multiselect";
  import IntegrationService from "@/services/resources/IntegrationService";
  import ClubService from "@/services/resources/ClubService";
  import Vue from "vue";
  
  const serviceClub = ClubService.build();
  const serviceIntegration = IntegrationService.build();
  
  export default {
	data() {
	  return {
		loading: false,
		submit: false,
		dados_user: {},
		userOk: true,
		flag_novo: false,
		hasContent: true,
		club: {
		  data: {
			access: null,
			type: "club",
			product_id: null,
		  },
		  options_projetos: [
			{
			  value: null,
			  text: this.$t("seller.products.greenn_club.text_1923"),
			},
		  ],
		  site_id: null,
		  options_conexao_tipo: [
			{
			  value: null,
			  text: this.$t("seller.products.greenn_club.text_1923"),
			},
			{
			  value: "course_class",
			  text: this.$t("seller.products.greenn_club.text_1924"),
			},
			{
			  value: "signature",
			  text: this.$t("seller.products.greenn_club.text_1925"),
			},
		  ],
		  options_conexao: [],
		  options: [],
		},
		newClub: {
		  product: {
			id: "",
			name: "",
		  },
		  flag_name: this.$t("seller.products.greenn_club.text_410"),
		  flag: false,
		  name: "",
		  course: "",
		  subdomain: ""
		},
		releaseRules: [],
	  };
	},
	components: {
	  Multiselect,
	},
	props: {
	  product: {
		type: Object,
		default: () => {
		  return {};
		},
	  }
	},
	computed: {
	  clubIntegration() {
		return this.$store.getters.userClub;
	  },
	  isAdvancedCourseFormat() {
		return (
			this.product.format === "POS_GRADUATION" ||
			this.product.format === "EXTENSION_COURSE"
		);
	  },
	  hasReleaseRules() {
		return this.releaseRules && this.releaseRules.length > 0;
	  }
	},
	watch: {
	  'product.id'(newId) {
		if (newId) {
		  this.fetchReleaseRules();
		}
	  }
	},
	methods: {
	  handleTypeChange() {
		this.hasContent = true;
	  },
	  handleSelectionChange(value) {
		this.hasContent = !(typeof (value) !== 'undefined' && value !== null && value.length > 0);
	  },
  
	  selecionarTodos(data) {
		if (data === "course_class") {
		  this.club.data.course_class_id = [...this.club.options].map((item) => ({
			value: item.value,
			text: item.text
		  }));
		  this.handleSelectionChange(this.club.data.course_class_id);
		} else {
		  this.club.data.signature_ids = [...this.club.options].map((item) => ({
			value: item.value,
			text: item.text
		  }));
		  this.handleSelectionChange(this.club.data.signature_ids);
		}
		this.$forceUpdate()
	  },
	  removerTodos(data) {
		if (data === "course_class") {
		  this.club.data.course_class_id = null;
		  this.handleSelectionChange(this.club.data.course_class_id);
		} else {
		  this.club.data.signature_ids = null;
		  this.handleSelectionChange(this.club.data.signature_ids);
		}
		this.$forceUpdate()
	  },
	  checkText() {
		if (typeof (this.club.data.course_class_id) !== 'undefined' && this.club.data.course_class_id !== null) {
		  return (this.club.data.course_class_id.length === this.club.options.length);
		}
  
		if (typeof (this.club.data.signature_ids) !== 'undefined' && this.club.data.signature_ids !== null) {
		  return (this.club.data.signature_ids.length === this.club.options.length);
		}
  
		return false;
	  },
	  loginClub() {
		this.$store.dispatch("clubLogin").catch(function (err) {
		});
	  },
  
	  atualizarConta() {
		open("/minha-conta");
		this.$bvModal.hide("modal-integracoes_club");
	  },
  
	  novoClub() {
		this.$validator.validateAll("club").then((result) => {
		  if (result) {
			this.submit = true;
			this.loading = true;
			const id_product = this.product.id;
			const name_product = this.product.name;
  
			let data = {
			  project_name: this.newClub.name,
			  course_title: name_product,
			  subdomain: this.newClub.subdomain,
			};
			this.$bvToast.toast(this.$t("seller.products.greenn_club.text_412"), {
			  title: "Voomp Play",
			  variant: "info",
			  autoHideDelay: 5000,
			  appendToast: true,
			});
  
			serviceClub
				.create(data)
				.then((response) => {
				  if (response.success) {
					this.$store
						.dispatch("clubVerification")
						.catch(function (err) {
						});
  
					this.$bvToast.toast(
						this.$t("seller.products.greenn_club.text_413"),
						{
						  title: "Voomp Play",
						  variant: "success",
						  autoHideDelay: 5000,
						  appendToast: true,
						}
					);
  
					this.flag_novo = true;
					this.toggleNewClub();
					this.clearFields();
					this.fetchProjetos();
				  } else {
					this.$bvToast.toast(
						this.$t("seller.products.greenn_club.text_414"),
						{
						  title: "Voomp Play",
						  variant: "danger",
						  autoHideDelay: 5000,
						  appendToast: true,
						}
					);
				  }
				  this.loading = false;
				  this.submit = false;
				})
				.catch((error) => {
				  this.loading = false;
				  this.submit = false;
				  console.log(error);
				});
		  }
		});
	  },
  
	  adicionarClub() {
		this.alertConfirmation(
			'Salvar configuração',
			'Tem certeza que deseja continuar?' ,
			() => {
			  this.submit = true;
			  this.loading = true;
			  this.club.data.product_id = this.product.id;
  
			  if (this.club.data.access === "signature") {
				this.club.data.signature_names = [...this.club.data.signature_ids].map(
					(item) => item.text
				);
  
				this.club.data.signature_ids = [...this.club.data.signature_ids].map(
					(item) => item.value
				);
			  } else {
				this.club.data.course_class_names = [
				  ...this.club.data.course_class_id,
				].map((item) => item.text);
  
				this.club.data.course_class_ids = [
				  ...this.club.data.course_class_id,
				].map((item) => item.value);
			  }
  
			  this.$validator.validateAll("club").then((result) => {
				if (!result) {
				  this.loading = false;
				  this.submit = false;
				  return;
				}
  
				serviceIntegration
					.create(this.club.data)
					.then((response) => {
					  if (response.success) {
						this.$store
							.dispatch("clubVerification")
							.catch(function (err) {
							});
						this.$bvToast.toast(
							this.$t("seller.products.greenn_club.text_415"),
							{
							  title: "Voomp Play",
							  variant: "success",
							  autoHideDelay: 5000,
							  appendToast: true,
							}
						);
						this.$bvModal.hide("modal-integracoes_club");
						this.clearFields();
						this.fetchReleaseRules();
						this.$emit("change", this.releaseRules);
					  } else {
						this.$bvToast.toast(
							this.$t("seller.products.greenn_club.text_416"),
							{
							  title: "Voomp Play",
							  variant: "danger",
							  autoHideDelay: 5000,
							  appendToast: true,
							}
						);
					  }
					})
					.catch((error) => {
					  console.log(error);
					})
					.finally(() => {
					  this.loading = false;
					  this.submit = false;
					});
			  });
			});
	  },
  
	  changeClub(event, flag = false) {
		delete this.club.data.course_class_id;
		delete this.club.data.signature_ids;
  
		this.fetchIntegrationClub(flag);
	  },
  
	  fetchIntegrationClub(flag = false) {
		this.loading = true;
		let data = {
		  type: "club",
		  access: this.club.data.access,
		  site_id: this.club.site_id,
		};
  
		serviceIntegration
			.search(data)
			.then((response) => {
			  this.club.options = [];
  
			  if (this.club.data.access === "signature") {
				response.forEach((item) => {
				  this.club.options.push({
					value: item.signature_id,
					text: ` ${item.site_name} | ${item.signature_title}`,
				  });
				});
			  } else {
				response.forEach((item) => {
				  this.club.options.push({
					value: item.course_class_id,
					text: ` ${item.site_name} | ${item.course_title} | ${item.course_class_title}`,
				  });
				});
			  }
  
			  if (this.flag_novo && !flag) {
				this.flag_novo = false;
			  }
			  if (!flag) {
				this.loading = false;
			  }
			})
			.catch((err) => {
			  this.loading = false;
			  console.log(err);
			});
	  },
  
	  toggleNewClub() {
		this.newClub.flag = !this.newClub.flag;
		if (this.newClub.flag)
		  this.newClub.flag_name = this.$t(
			  "seller.products.greenn_club.text_417"
		  );
		if (!this.newClub.flag)
		  this.newClub.flag_name = this.$t(
			  "seller.products.greenn_club.text_410"
		  );
	  },
  
	  clearFields() {
		this.club.data.access = null;
		this.club.options = [];
		this.club.site_id = null;
		this.club.data.course_class_id = null;
		this.club.data.signature_ids = null;
		this.loading = false;
		this.newClub = {
		  product: {
			id: "",
			name: "",
		  },
		  flag_name: this.$t("seller.products.greenn_club.text_410"),
		  flag: false,
		  name: "",
		  course: "",
		  subdomain: ""
		};
	  },
  
	  changeProjeto(value) {
		this.club.site_id = value;
		this.club.data.access = null;
  
		if (this.club.site_id) {
		  this.hasContent = true;
		}
  
		this.$forceUpdate();
	  },
  
	  fetchProjetos() {
		this.loading = true;
		serviceClub
			.search()
			.then((response) => {
			  this.$store.dispatch("clubVerification").catch(function (err) {
			  });
			  if (response.length) {
				this.club.options_projetos = [
				  {
					value: null,
					text: this.$t("seller.products.greenn_club.text_1923"),
				  },
				];
				[...response].forEach((item) => {
				  this.club.options_projetos.push({
					value: item.id,
					text: item.name,
				  });
				});
  
				if (this.flag_novo) {
				  this.club.site_id = null;
				  this.club.site_id = this.club.options_projetos[
				  this.club.options_projetos.length - 1
					  ].value;
  
				  this.club.data.access = "signature";
				  this.changeClub(this.club.data.access, true);
  
				  setTimeout(() => {
					this.club.data.access = "course_class";
					this.changeClub();
				  }, 1000);
  
				}
			  } else {
				this.$bvToast.toast(
					this.$t("seller.products.greenn_club.text_418"),
					{
					  title: "Voomp Play",
					  variant: "info",
					  autoHideDelay: 5000,
					  appendToast: true,
					}
				);
				this.toggleNewClub();
				setTimeout(() => {
				  if (document.querySelector("#project_name")) {
					document.querySelector("#project_name").focus();
				  }
				}, 1000);
				this.loading = false;
			  }
			})
			.catch((error) => {
			  console.log(error);
			  this.$bvToast.toast(this.$t("seller.products.greenn_club.text_418"), {
				title: "Voomp Play",
				variant: "info",
				autoHideDelay: 5000,
				appendToast: true,
			  });
			  this.toggleNewClub();
			  setTimeout(() => {
				if (document.querySelector("#project_name")) {
				  document.querySelector("#project_name").focus();
				}
			  }, 1000);
			})
			.finally(() => {
			  if (!this.flag_novo) this.loading = false;
			});
	  },
  
	  initializeData() {
		this.hasContent = true;
		this.dados_user = Object.assign({}, this.$store.state.user.user);
		if (
			this.dados_user.name &&
			this.dados_user.email &&
			this.dados_user.cellphone
		) {
		  this.userOk = true;
		  this.fetchProjetos();
		  this.fetchReleaseRules();
		} else {
		  this.userOk = false;
		}
	  },
	  alertConfirmation(title, message, callback) {
		Vue.swal({
		  title: title,
		  text: message,
		  type: "danger",
		  showCancelButton: true,
		  confirmButtonText: "Continuar",
		  cancelButtonText: "Cancelar",
		  customClass: "sweet-container",
		  confirmButtonClass: "button button-danger mt-3 mb-3",
		  cancelButtonClass: "button button-link-info mr-4 mt-3 mb-3",
		  buttonsStyling: false,
		  reverseButtons: true,
		}).then((result) => {
		  if (result.isConfirmed) {
			callback();
		  }
		});
	  },
	  fetchReleaseRules() {
		if (!this.product.id) {
		  return;
		}
		let data = {
		  product_id: this.product.id,
		  type: "club",
		  url: "list",
		};
  
		serviceIntegration
		  .search(data)
		  .then((response) => {
			this.releaseRules = response;
		  })
		  .catch((error) => {
			console.log(error);
			this.releaseRules = [];
		  })
		  .finally(() => {
			this.loading = false;
		  });
	  }
	},
	mounted() {
	  this.initializeData();
	}
  };
  </script>
  
  <style scoped>
  p {
	margin: 0;
  }
  
  .title-inter {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 30px;
	color: $black;
  }
  
  .form-group + .form-group {
	margin-top: 15px;
  }
  
  /* // codigo de verificação g digital */
  .codigo-verifica {
	max-width: 60%;
  }
  
  @media screen and (max-width: 768px) {
	.codigo-verifica {
	  max-width: 100%;
	}
  }
  
  .codigo-verifica p {
	font-size: 14px;
	font-weight: normal;
	color: #81858e;
	line-height: 1.5;
	margin-bottom: 20px;
  }
  
  .sem-codigo {
	font-size: 14px;
	color: #333;
  }
  
  .sem-codigo:hover {
	font-weight: normal;
  }
  
  .grid-events {
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin: 20px 0 10px;
  }
  
  .titulo-acao {
	font-weight: 600;
	font-size: 14px;
	margin-bottom: 10px;
  }
  
  .check-box .info-checkbox {
	font-size: 13px;
	font-weight: 500;
	margin-left: 5px;
	cursor: pointer;
	max-width: 250px;
	margin-top: 15px !important;
  }
  
  .sub-dominio {
	font-weight: normal;
	color: #81858e;
	font-size: 13px;
	line-height: 1.5;
	margin-top: 5px;
  }
  
  /* legenda */
  .legenda {
	color: #81858e;
	font-size: 14px;
	margin: 0;
	margin-top: 20px;
	text-align: center;
  }
  
  .legenda-form {
	color: #81858e;
	font-size: 13px;
	margin: 0;
	position: absolute;
	/* top: 0; */
	right: 0;
  }
  
  .legenda-form-tp {
	color: #002E74;
	font-size: 13px;
	margin: 0;
	position: absolute;
	top: 0;
	right: 0;
	text-decoration: underline;
	line-height: 15.73px;
	font-weight: 400;
  }
  
  /* dados incompletos */
  .dados-incompletos h6 {
	font-weight: 600;
	font-size: 16px;
  }
  
  .dados-incompletos p {
	color: #81858e;
	font-size: 14px;
	line-height: 1.5;
	margin-bottom: 5px;
	font-weight: normal;
  }
  
  /* btn novo projeto */
  .novo-projeto {
	padding: 0 25px !important;
	height: 40px !important;
	font-size: 12px;
  }
  
  .novo-projeto:disabled {
	opacity: 1 !important;
  }
  
  .action-club {
	display: grid;
  }
  </style>
  